export enum StripeActionType {
    setPaymentType = 'setPaymentType',
}

export interface SetPaymentTypeAction {
    type: StripeActionType.setPaymentType;
    payload: string | null;
}

export const setPaymentType = (
    paymentType: string | null,
): SetPaymentTypeAction => ({
    type: StripeActionType.setPaymentType,
    payload: paymentType,
});

export type StripeAction = SetPaymentTypeAction;
